import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, spacing, variant, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const indicatorVariant = variant({
  prop: "variant",
  variants: {
    primary: {
      backgroundColor: "primary.300"
    },
    warning: {
      backgroundColor: "warning.300"
    },
    danger: {
      backgroundColor: "danger.300"
    }
  }
});
const indicatorSize = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "base"
    },
    md: {
      fontSize: "lg"
    }
  }
});
const Indicator = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${indicatorSize};
    color: ${themeMode({
  dark: palette("neutral.50"),
  light: palette("neutral.900")
})};
`;
const IndicatorIcon = styled.div`
    width: 1em;
    height: 1em;
    border-radius: 50%;
    margin-right: ${spacing(3)};
    ${indicatorVariant};
`;

export { Indicator, IndicatorIcon };
//# sourceMappingURL=styled.es.js.map
